






























































import { Mixins } from "vue-mixin-decorator";
import { Component, Prop } from "vue-property-decorator";
import { Action, Mutation, Getter } from "vuex-class";
import GeneralMixin from "@/mixin";
import {
  ICategory,
  ICategoryCreateRequest,
  ICategoryUpdateRequest
} from "@/types/category";

@Component({
  components: {}
})
export default class extends Mixins<GeneralMixin>(GeneralMixin) {
  @Action("category/adminGet")
  public getCategory!: (category_id: number) => void;

  @Action("category/adminCreate")
  public create!: (params: ICategoryCreateRequest) => boolean;

  @Action("category/adminUpdate")
  public update!: (data: {
    category_id: number;
    params: ICategoryUpdateRequest;
  }) => boolean;

  @Action("category/adminDelete")
  public deleteCategiry!: (category_id: number) => boolean;

  @Action("category/adminIsDeletable")
  public categoryIsDeletable!: (category_id: number) => boolean;

  @Getter("category/canDelete")
  public deletable!: boolean;

  @Getter("category/single")
  public category!: ICategory;

  @Mutation("category/clear")
  public clear!: () => void;

  @Prop({ default: false })
  public inModal!: boolean;

  public category_id = 0;
  public dialog = false;

  public valid = true;
  public lazy = false;

  public rules = {
    name: [
      (v: string) => !!v || "カテゴリ名は必須です",
      (v: string) =>
        (v && v.length <= 30) || "現場名は30文字以下で入力してください"
    ]
  };

  public params: ICategoryUpdateRequest = {
    name: "",
    is_haploid: false
  };

  //--------
  // コンポーネント作成時実行
  public async created() {
    this.category_id = Number(this.$route.params.category_id);
    this.clear();

    // 編集
    if (this.category_id) {
      // await this.getCategory(this.category_id);
      // await this.categoryIsDeletable(this.category_id);
      await Promise.all([
        this.getCategory(this.category_id),
        this.categoryIsDeletable(this.category_id)
      ]);
      this.setDefault();
    }
  }

  //--------
  // 更新時デフォルト値をセットする
  private setDefault() {
    this.params.name = this.category.name;
    this.params.is_haploid = this.category.is_haploid;
  }

  //--------
  // 確定ボタンが押された際の挙動
  // 更新時と作成時で問合せ先が違う
  public async submit() {
    let result = false;
    if (this.category_id) {
      result = await this.update({
        category_id: this.category_id,
        params: this.params
      });
    } else {
      result = await this.create(this.params);
    }
    if (this.inModal) {
      this.$emit("created");
    } else if (result) {
      this.$router.go(-1);
    }
  }

  //--------
  // 削除確認画面
  public destroyConfirm() {
    this.dialog = true;
  }

  //--------
  // 削除実行
  public async destroy() {
    this.dialog = false;
    if (await this.deleteCategiry(this.category_id)) {
      this.$router.go(-1);
    }
  }
}
